import { BasePage } from '@/components/ui/base-page';
import { NewsletterSubscription } from '@/components/forms/NewsletterSubscription.tsx';

export function NewsletterPage() {
    return (
        <BasePage
            title="Newsletter Subscription"
            description="Subscribe to our newsletter to stay updated with our latest insights and updates"
        >
            <div className="container py-12 max-w-3xl mx-auto">
                <div className="bg-muted p-8 rounded-xl">
                    <h1 className="text-3xl font-bold mb-6 text-center">Newsletter Subscription</h1>
                    <p className="text-muted-foreground mb-8 text-center">
                        Stay informed with the latest industry updates, investment opportunities,
                        and exclusive content delivered straight to your inbox.
                    </p>

                    <NewsletterSubscription className="max-w-xl mx-auto" />
                </div>
            </div>
        </BasePage>
    );
} 